/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/shared/global/util.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'Fandango/util', exports: {} }; const exports = module.exports;

import $ from '@grins/fd-modules/jQuery';

import { Fandango as Fandango_dtmData_fandangoDtmData } from '@grins/fd-modules/splits/require-core';

const { dtmData: fandangoDtmData } = Fandango_dtmData_fandangoDtmData;
import { Fandango_sanitizer as sanitizer } from '@grins/fd-modules/splits/onering-global';

const RegExes = {
    FANDANGO_DOMAIN: /^(?:(?:https?:)?\/\/)?[a-z0-9_.-]+\.fandango\.com(?:[/?]|$)/i,
}
function isWithinViewport(el, offset) {
    const rect = el.getBoundingClientRect();
    return (rect.bottom <= document.documentElement.clientHeight + offset &&
        rect.right <= document.documentElement.clientWidth + offset);
}
function debounce(interval, el, opts, cb) {
    if (!interval || !Number(interval)) {
        return null;
    }
    let timeout;
    return function () {
        const _this = this;
        const _arguments = arguments;
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            cb.apply(_this, [el, opts, _arguments]);
        }, interval);
    };
}

const defaultLazyloadOptions = {
    container: 'fd-lazy-container',
    dataAttr: 'data-fd-lazy-image',
    viewPortOffset: 100,
    debounce: 100,
    useViewport: true
}
function setBgImage(image, dataAttrName) {
    if (image.getAttribute(dataAttrName)) {
        image.style.backgroundImage = 'url(' + image.getAttribute(dataAttrName) + ')';
        image.removeAttribute(dataAttrName);
    }
}
function lazyLoad(options) {
    options = Object.assign({}, defaultLazyloadOptions, options);
    const $lazyContainers = $('.' + options.container);
    if (!$lazyContainers) {
        return;
    }
    $.each($lazyContainers, (index, container) => {
        const images = $(container).find('[' + options.dataAttr + ']');
        if (!images.length) {
            return;
        }
        const loadImagesDebounced = debounce(options.debounce, container, options, loadImages);
        function loadImages() {
            if (images.length === 0) {
                container.removeEventListener('scroll', loadImagesDebounced);
                $(container).removeClass(options.container);
                if ($('.' + options.container).length === 0) {
                    window.removeEventListener('scroll', loadImagesDebounced);
                }
                return;
            }
            for (let index = images.length - 1; index >= 0; index--) {
                const image = images[index];
                if (!options.useViewport || isWithinViewport(image, options.viewPortOffset)) {
                    setBgImage(image, options.dataAttr);
                    images.splice(index, 1);
                }
            }
        }
        container.addEventListener('scroll', loadImagesDebounced);
        window.addEventListener('scroll', loadImagesDebounced);
        if (options.useViewport) {
            loadImages();
        }
    });
}
function navigate(url) {
    if (!url) {
        return;
    }
    function isFandangoDomain(url) {
        return RegExes.FANDANGO_DOMAIN.test(url);
    }
    function isRelativeUrl(url) {
        return url && url.indexOf('//') === -1;
    }
    if (!isFandangoDomain(url) && !isRelativeUrl(url)) {
        return;
    }
    window.location.assign(sanitizer.url(url));
}
function track(key, dtmData) {
    if (!window._satellite || !window._satellite.track || !key) {
        return;
    }
    if (dtmData && typeof dtmData === 'object') {
        Object.assign(fandangoDtmData || {}, dtmData);
    }
    window._satellite.track(key);
}
export default {
    debounce,
    isWithinViewport,
    lazyLoad,
    navigate,
    track,
};